const ComboItemCtrl = function (customOptionsService, productService, $sce, $timeout, isMobileService, modalService, comboStateService) {
  const ctrl = this;
  const isMobile = isMobileService.getValue();
  ctrl.isColorAndSizeActive = true;
  ctrl.$onInit = function () {
    ctrl._summary = [];
    ctrl.sizeColorsData = {
      Sizes: [],
      Colors: [],
      SizesControlType: 0,
      ColorsControlType: 0,
      ColorIconWidthDetails: 0,
      ColorIconHeightDetails: 0
    };
    comboStateService.registerItem(ctrl);
    ctrl.getActivePosition();
  };
  ctrl.$onDestroy = function () {
    comboStateService.unregisterItem(ctrl);
  };
  ctrl.getCustomOptions = function () {
    customOptionsService.getData(ctrl.activePosition.ProductId).then(customOptions => {
      ctrl.customOptions = customOptions;
    });
  };
  ctrl.selectItem = function ($event) {
    if (ctrl.onClickFn) {
      ctrl.onClickFn({
        event: $event,
        elem: ctrl.elem,
        index: ctrl.itemIndex
      });
    }
    if (isMobile) {
      const className = $event.target.className;
      if (className.includes('combo-size-color-viewers')) {
        return;
      } else {
        ctrl.openPositionsModal();
      }
    }
  };
  ctrl.openPositionsModal = function () {
    if (isMobile) {
      if (ctrl.positions != null && ctrl.positions.length > 0) {
        ctrl.activePositionId = ctrl.activePosition.ProductId;
        ctrl.activePosition.priceAdded = ctrl.activePosition.PriceDifference;
      }
      modalService.renderModal('modal_comboPositions', 'Заменить продукт', `<combo-positions-modal
                    positions="comboItem.positions"
                    active-position="comboItem.activePosition"
                    active-position-id="comboItem.activePositionId"
                    on-select-position="comboState.setActivePosition(position)"
                    on-edit-options="comboState.openCustomOptionsModal()"
                    price-added="comboItem.activePosition.priceAdded"
                    currency-symbol="comboState.currencySymbol"
                    close="comboItem.closePositionsModal($event)">
                </combo-positions-modal>`, null, {
        destroyOnClose: true,
        modalClass: 'modal-positionsview'
      }, {
        comboItem: ctrl,
        comboState: comboStateService
      });
      modalService.getModal('modal_comboPositions').then(modal => {
        modal.modalScope.open(true);
      });
    }
  };
  ctrl.closePositionsModal = function () {
    modalService.close('modal_comboPositions');
  };
  ctrl.prepareOffers = function (data) {
    const existingIds = new Set(ctrl.positions.map(p => p.OfferId));
    data.Offers = data.Offers.filter(offer => existingIds.has(offer.OfferId)).map(offer => {
      if (offer.Available && angular.isString(offer.Available)) {
        offer.Available = $sce.trustAsHtml(offer.Available);
      }
      return offer;
    });
    return data;
  };
  ctrl.getActivePosition = function () {
    if (ctrl.positions.length > 0) {
      ctrl.activePosition = ctrl.positions.find(pos => pos.Default === true);
    }
    if (ctrl.activePosition) {
      ctrl.activePosition.priceAdded = ctrl.activePosition.PriceDifference;
      ctrl.activePosition.PriceWithOptions = null;
    }
    ctrl.getCustomOptions();
    ctrl.getSizeColorPickerJson();
  };
  ctrl.setActivePositionByOffer = function (offerId) {
    const found = ctrl.positions.find(pos => pos.OfferId === offerId);
    if (found) {
      let matchedPosition = null;
      ctrl.positions.forEach(item => {
        item.priceAdded ??= item.PriceDifference;
        const isMatch = item.OfferId === offerId;
        item.Default = isMatch;
        if (isMatch) {
          matchedPosition = item;
        }
      });
      ctrl.activePosition = matchedPosition;
      comboStateService.recalcPrice();
      if (comboStateService.posCtrl) {
        comboStateService.posCtrl.activePosition = ctrl.activePosition;
      }
    }
  };
  ctrl.setEditPositionOptions = function (e) {
    if (!ctrl.isSelected) {
      ctrl.selectItem(e);
    }
    $timeout(() => {
      if (ctrl.onClickEditOptions) {
        ctrl.onClickEditOptions();
      }
    });
  };
  ctrl.getSizeColorPickerJson = function () {
    if (ctrl.colorsViewer || ctrl.sizesViewer) {
      ctrl.isColorAndSizeActive = false;
    }
    productService.getSizeColorPickerJson(ctrl.activePosition.ProductId, ctrl.activePosition.ColorId, ctrl.activePosition.SizeId).then(({
      data
    }) => {
      if (data) {
        ctrl.sizeColorsData = data;
        ctrl.sizeColorsData.Sizes = ctrl.sizeColorsData.Sizes ? JSON.parse(ctrl.sizeColorsData.Sizes) : '';
        ctrl.sizeColorsData.Colors = ctrl.sizeColorsData.Colors ? JSON.parse(ctrl.sizeColorsData.Colors) : '';
        productService.getOffers(ctrl.activePosition.ProductId, ctrl.sizeColorsData.SelectedColorId, ctrl.sizeColorsData.SelectedSizeId).then(offers => {
          if (offers) {
            ctrl.offers = ctrl.prepareOffers(offers);
            ctrl.offerSelected = productService.findOfferSelected(offers.Offers, offers.StartOfferIdSelected);
          }
        }).finally(() => {
          ctrl.isColorAndSizeActive = true;
        });
      }
    });
  };
  ctrl.initColors = function (colorsViewer) {
    ctrl.colorsViewer = colorsViewer;
    if (ctrl.colorsViewerDefer) {
      ctrl.colorsViewerDefer.resolve();
      delete ctrl.colorsViewerDefer;
    }
    if (ctrl.colorsViewer && Array.isArray(ctrl.colorsViewer.colors) && ctrl.offers && ctrl.offers.Offers) {
      const activeColorIds = new Set(ctrl.offers.Offers.map(offer => offer.Color?.ColorId));
      ctrl.colorsViewer.colors.forEach(color => {
        if (!activeColorIds.has(color.ColorId)) {
          color.Available = false;
        }
      });
    }
    if (ctrl.offerSelected?.Color) {
      ctrl.setColorSelected(ctrl.colorsViewer, ctrl.offerSelected.Color.ColorId);
    }
  };
  ctrl.changeColor = function (color) {
    if (!ctrl.offers || !ctrl.offers.Offers) return;
    ctrl.colorSelected = color;
    if (ctrl.sizesViewer) {
      ctrl.sizeSelected = ctrl.getSizeAvalable(ctrl.offers.Offers, ctrl.colorSelected.ColorId, ctrl.sizesViewer.sizes, ctrl.offers.AllowPreOrder);
      if (ctrl.sizeSelected != null && ctrl.sizesViewer.sizeSelected?.SizeId !== ctrl.sizeSelected.SizeId) {
        ctrl.sizesViewer.sizeSelected = ctrl.sizeSelected;
      }
    }
    ctrl.offerSelected = productService.getOffer(ctrl.offers.Offers, ctrl.colorSelected.ColorId, ctrl.sizeSelected && ctrl.sizeSelected.isDisabled === false ? ctrl.sizeSelected.SizeId : null, ctrl.offers.AllowPreOrder);
    if (!ctrl.offerSelected) return;
    ctrl.setActivePositionByOffer(ctrl.offerSelected.OfferId);
  };
  ctrl.setColorSelected = function (colorsViewer, colorId) {
    for (let i = colorsViewer.colors.length - 1; i >= 0; i--) {
      if (colorsViewer.colors[i].ColorId === colorId) {
        ctrl.colorSelected = colorsViewer.colors[i];
        if (!colorsViewer.colorSelected || colorsViewer.colorSelected.ColorId !== ctrl.colorSelected.ColorId) {
          colorsViewer.colorSelected = ctrl.colorSelected;
        }
        break;
      }
    }
  };
  ctrl.initSizes = function (sizesViewer) {
    ctrl.sizesViewer = sizesViewer;
    if (ctrl.sizesViewerDefer) {
      ctrl.sizesViewer.sizes = JSON.parse(JSON.stringify(ctrl.sizesViewer.sizes));
      ctrl.sizesViewerDefer.resolve();
      delete ctrl.sizesViewerDefer;
    }
    if (ctrl.offerSelected?.Size) {
      ctrl.setSizeSelected(ctrl.sizesViewer, ctrl.offerSelected.Size.SizeId);
    }
  };
  ctrl.changeSize = function (size) {
    if (!ctrl.offers || !ctrl.offers.Offers) return;
    ctrl.sizeSelected = size;
    ctrl.offerSelected = productService.getOffer(ctrl.offers.Offers, ctrl.colorSelected ? ctrl.colorSelected.ColorId : 0, ctrl.sizeSelected ? ctrl.sizeSelected.SizeId : null);
    if (!ctrl.offerSelected) return;
    ctrl.setActivePositionByOffer(ctrl.offerSelected.OfferId);
  };
  ctrl.setSizeSelected = function (sizesViewer, sizeId) {
    for (let i = sizesViewer.sizes.length - 1; i >= 0; i--) {
      if (sizesViewer.sizes[i].SizeId === sizeId) {
        ctrl.sizeSelected = sizesViewer.sizes[i];
        if (!sizesViewer.sizeSelected) {
          sizesViewer.sizeSelected = ctrl.sizeSelected;
        }
        break;
      }
    }
    ctrl.sizeSelected = ctrl.getSizeAvalable(ctrl.offers.Offers, ctrl.colorSelected?.ColorId ?? 0, ctrl.sizesViewer.sizes, ctrl.offers.AllowPreOrder, true);
  };
  ctrl.getSizeAvalable = function (offers, colorId, sizes, allowPreorder, notChangeSelectdSize) {
    if (!Array.isArray(offers) || !Array.isArray(sizes)) return ctrl.sizeSelected;
    sizes.forEach(function (item) {
      item.isDisabled = true;
    });
    for (var i = offers.length - 1; i >= 0; i--) {
      var offerItem = offers[i];
      if (!offerItem || offerItem.Size == null) continue;
      var filterByColor = colorId && offerItem.Color;
      var matchesColor = !filterByColor || offerItem.Color.ColorId === colorId;
      if (!matchesColor) continue;
      for (var j = sizes.length - 1; j >= 0; j--) {
        if (offerItem.Size.SizeId === sizes[j].SizeId && (allowPreorder === true || offerItem.Amount != null && offerItem.Amount > 0) && offerItem.IsAvailable === true) {
          sizes[j].isDisabled = false;
          break;
        }
      }
    }
    if (!notChangeSelectdSize && (!ctrl.sizeSelected || ctrl.sizeSelected.isDisabled === true)) {
      for (var k = 0; k < sizes.length; k++) {
        if (sizes[k].isDisabled === false) {
          return sizes[k];
        }
      }
      return null;
    }
    return ctrl.sizeSelected;
  };
  ctrl.getSelectedOptionsSummary = function () {
    var summary = customOptionsService.getSelectedOptionsSummary(ctrl.customOptions);
    if (!angular.equals(ctrl._summary, summary)) {
      ctrl._summary = summary;
    }
    return ctrl._summary;
  };
};
ComboItemCtrl.$inject = ["customOptionsService", "productService", "$sce", "$timeout", "isMobileService", "modalService", "comboStateService"];
export default ComboItemCtrl;